import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';

@Injectable({
  providedIn: 'root'
})
export class PontoEncontroDBService extends DatabaseService {
    override classname: string = 'PontoEncontroDBService';
    override table = 'ponto_encontro';

    protected override migration: number = 1;

    override indices = [
        { name: "by_id", field: "id", unique: false, multiEntry: false },
        { name: "by_nome", field: "nome", unique: false, multiEntry: false },
        { name: "by_sinc", field: "sinc", unique: false, multiEntry: false }
    ];
}
